import { createContext } from 'react'

interface ConnectAppContextInterface {
  isGameTabEnabled: boolean
  isPlayerTabEnabled: boolean
  isTeamTabEnabled: boolean
  isTeamInsightsTabEnabled: boolean
  isUsageTabEnabled: boolean
  tabs: string[]
  pathNames: string[]
  isPremiumSubscriber: boolean
}

const defaultProviderValue = {
  isGameTabEnabled: true,
  isPlayerTabEnabled: true,
  isTeamTabEnabled: true,
  isTeamInsightsTabEnabled: true,
  isUsageTabEnabled: true,
  tabs: [],
  pathNames: [],
  isPremiumSubscriber: false,
}
export const ConnectAppContext = createContext<ConnectAppContextInterface>(defaultProviderValue)
